import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class ErrorHandlerService {
  abstract handleClientError(error: Error): void;

  abstract handleServerError(error: HttpErrorResponse): void;
}
